/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import * as Styled from "./styles";

import { Box, CircularProgress, Container, Typography } from "@mui/material";
import { ReturnButton } from "components/ReturnButton";
import { useAuth } from "shared/providers/auth";
import { useParams } from "react-router-dom";
import { getAppraisal } from "requests/Appraisal";
import toast from "react-hot-toast";
import { IAvaliation } from "shared/types/Avaliation";

const getReasonParts = (reason?: string) => {
  const normalizedReason = typeof reason === "string" ? reason.trim() : "";

  if (!normalizedReason) {
    return {
      careReason: "",
      periodontReason: "",
      cirurgyReason: "",
      fallbackReason: "",
    };
  }

  const parts = normalizedReason.split("|").map((part) => part.trim());

  if (parts.length === 1) {
    return {
      careReason: "",
      periodontReason: "",
      cirurgyReason: "",
      fallbackReason: parts[0],
    };
  }

  const [careReason = "", periodontReason = "", cirurgyReason = ""] = parts;

  return {
    careReason,
    periodontReason,
    cirurgyReason,
    fallbackReason: "",
  };
};

const AvalitationUser: React.FC<{
  idPacientParam?: number;
  onClick?: () => void;
}> = ({ idPacientParam, onClick }) => {
  const { user } = useAuth();
  const { idPacient } = useParams();
  const [loading, setLoading] = React.useState<boolean>(false);

  const [complaint, setComplaint] = React.useState<IAvaliation | null>(null);

  const avaliationAll = async () => {
    const patientId = Number(
      idPacientParam && idPacientParam > 0 ? idPacientParam : idPacient
    );

    if (!user?.data?.id || !patientId) {
      setComplaint(null);
      return;
    }

    setLoading(true);

    try {
      const { status, data } = await getAppraisal(user.data.id, patientId);

      if ([200, 201].includes(status)) {
        setComplaint(data?.data ?? null);
      } else {
        setComplaint(null);
        toast.error(data.message);
      }
    } catch (e: any) {
      setComplaint(null);
      toast.error("Não foi possível carregar a avaliação.");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    avaliationAll();
  }, []);

  const { careReason, periodontReason, cirurgyReason, fallbackReason } =
    React.useMemo(() => getReasonParts(complaint?.reason), [complaint?.reason]);

  return (
    <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
      <Container maxWidth="xl">
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <ReturnButton title="Avaliação" onClick={onClick} />

            <Styled.ContainerPictures>
              {complaint ? (
                <>
                  <Styled.BoxDescription>
                    <h5>Queixa principal</h5>

                    <Typography>{complaint.complaint}</Typography>
                  </Styled.BoxDescription>

                  <Styled.BoxDescription>
                    <h5>Indicação para Tratamento Ortodôntico?</h5>

                    <Typography>
                      {complaint.recommendation === "S" ? "Sim" : "Não"}
                    </Typography>
                  </Styled.BoxDescription>

                  <Styled.BoxDescription>
                    <h5>Início Imediato do Tratamento Ortodôntico?</h5>

                    <Typography>
                      {complaint.immediate ? "Sim" : "Não"}
                    </Typography>
                  </Styled.BoxDescription>

                  {complaint.obs && complaint.immediate && (
                    <Styled.BoxDescription>
                      <h5>Motivo da Indicação</h5>

                      <Typography>{complaint.obs}</Typography>
                    </Styled.BoxDescription>
                  )}
                  {careReason.length > 0 && (
                    <Styled.BoxDescription>
                      <h5>Cáries extensas</h5>

                      <Typography>{careReason}</Typography>
                    </Styled.BoxDescription>
                  )}

                  {periodontReason.length > 0 && (
                    <Styled.BoxDescription>
                      <h5>Problema periodontal</h5>

                      <Typography>{periodontReason}</Typography>
                    </Styled.BoxDescription>
                  )}

                  {cirurgyReason.length > 0 && (
                    <Styled.BoxDescription>
                      <h5>Caso Cirurgico</h5>

                      <Typography>{cirurgyReason}</Typography>
                    </Styled.BoxDescription>
                  )}

                  {fallbackReason.length > 0 && (
                    <Styled.BoxDescription>
                      <h5>Motivos registrados</h5>

                      <Typography>{fallbackReason}</Typography>
                    </Styled.BoxDescription>
                  )}
                </>
              ) : (
                <Box sx={{ textAlign: "center", marginTop: "20px" }}>
                  <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                    Não há avaliação para este paciente.
                  </Typography>
                </Box>
              )}
            </Styled.ContainerPictures>
          </>
        )}
      </Container>
    </Box>
  );
};

export { AvalitationUser };
